// ListWidget Index - Registrierung des Widgets

import ListWidget from './ListWidget';
import ListWidgetSettings from './ListWidgetSettings';

// Widget-Definition
const listWidgetDefinition = {
  type: 'list-widget',
  name: 'Aggregated List Widget',
  description: 'Zeigt eine aggregierte Liste mit Tätigkeitsbereichen oder Vorsorgearten an',
  defaultConfig: {
    title: 'Tätigkeiten',
    isActive: true,
    position: 0,
    size: { width: 3, height: 2 }, // Standardgröße: 3x2
    globalSettings: {
      overviewLink: '#vorsorgekartei',
      overviewLinkText: 'Zur Übersicht',
      apiEndpoint: '/api/widget/list-widget-data',
      primaryFilterLabel: 'BEREICHE:',
      columnHeaderLabel: 'Bereich',
      selectedAreas: []
    },
    localSettings: {
      selectedAreas: [],
      statusFilter: '',
      isTop5Mode: true
    }
  },
  component: ListWidget,
  settingsComponent: ListWidgetSettings
};

export { ListWidget, ListWidgetSettings, listWidgetDefinition };
